import { render } from "./CardNote.vue?vue&type=template&id=1dd62c7a&scoped=true"
import script from "./CardNote.vue?vue&type=script&lang=js"
export * from "./CardNote.vue?vue&type=script&lang=js"

import "./CardNote.vue?vue&type=style&index=0&id=1dd62c7a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd62c7a"]])

export default __exports__